__webpack_require__.p = "/coursecraft-ai/";